import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./case-studies.css";
import CaseStudyHeroBanner from "./hero";
import ContactForm from "../../components/forms/contact-form";
import TestimonialCarousel from "../../components/carousels/testimonial-carousel";
import TestimonialVideoPlayer from "../../components/videos/testimonial-video";
import ProductPartners from "../../components/product-partners";
import { useNavigate } from "react-router-dom";
import SentryVideoTestimonial from "../../components/videos/sentry-video";
import iot from "../../images/case-studies/iot-img.webp";
import ai from "../../images/case-studies/ai-img.webp";
import cloud from "../../images/case-studies/cloud-img.webp";
import aws from "../../images/case-studies/devops-img.webp";
import automation from "../../images/case-studies/automation-img.webp";
import ml from "../../images/case-studies/ml-img.webp";
import blockchain from "../../images/case-studies/blockchain-img.webp";
import crossplatform from "../../images/case-studies/cross-platform-img.webp";
import android from "../../images/case-studies/android-img.webp";

const CaseStudies = () => {

    const navigate = useNavigate()
    const handlePageLink = (path) => {
        navigate(path);
    }
    const caseStudies = [
        {
            title: "IoT",
            imgSrc: iot,
            link: "/resources/iot_case_study",
            buttonText: "Realtime Vehicle Telemerty",
        },
        {
            title: "AI / ML",
            imgSrc: ai,
            link: "/resources/ai_case_study",
            buttonText: "Sentiment Analysis - Recommendation System",
        },
        {
            title: "Cloud Computing",
            imgSrc: cloud,
            link: "/resources/cloud_case_study",
            buttonText: "Predicting Customer Churn - Salesforce & AWS Services",
        },
        {
            title: "AWS DevOps",
            imgSrc: aws,
            link: "/resources/rpa_case_study",
            buttonText: "Automation of Deployments [PostgreSQL-NodeJS-React]",
        },
        {
            title: "Automation Testing",
            imgSrc: automation,
            link: "/resources/emr_case_study",
            buttonText: "Electronic Medical Records Application",
        },
        {
            title: "Machine Learning",
            imgSrc: ml,
            link: "/resources/ocr_case_study",
            buttonText: "Documents Processing System using OCR",
        },
        {
            title: "Block Chain Technology",
            imgSrc: blockchain,
            link: "/resources/blockchain_case_study",
            buttonText: "Blockchain Technology",
        },
        {
            title: "Cross Platform Development",
            imgSrc: crossplatform,
            link: "/resources/crossplatform_case_study",
            buttonText: "eCommerce Web and Mobile App",
        },
        {
            title: "Android App Development",
            imgSrc: android,
            link: "/resources/android_case_study",
            buttonText: "Android App Development",
        },
    ];

    return (
        <section className="case-study-section">
            <CaseStudyHeroBanner />
            <Container fluid className="py-4 ">
                <Row>
                    <Col xs={12}>
                        <h2 className="text-primary text-center ft-wt-700 mb-3">
                            Our Case Studies
                        </h2>
                    </Col>
                    {caseStudies.map((study, index) => (
                        <Col xs={12} lg={4} className="mb-3" key={index}>
                            <Card className="h-100">
                                <div className="case-study-card">
                                    <Card.Img src={study.imgSrc} alt={study.title} />
                                </div>
                                <Card.Body className="caseStudy-card-body">
                                    <Card.Title className="text-primary fw-bold mb-3">
                                        {study.title}
                                    </Card.Title>
                                    <div className="card-button">
                                        <Button variant="primary" onClick={() =>
                                            handlePageLink(study.link)
                                        }>
                                            {study.buttonText}
                                        </Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
            <TestimonialCarousel />
            <Container>
                <Row>
                    <Col xs="12" lg="6">
                        <TestimonialVideoPlayer />
                    </Col>
                    <Col xs="12" lg="6">
                        <SentryVideoTestimonial />
                    </Col>
                </Row>
            </Container>
            <ContactForm />
            <ProductPartners />
        </section>
    );
};

export default CaseStudies;
